import dangerousGoodsData from "@/GeneratedFixtures/DangerousGoods.json";

// TDG Schedule 2 special provision 16: the technical name must accompany the
// proper shipping name, and carriers (Manitoulin) reject a BOL without it.
const SPECIAL_PROVISION_TECHNICAL_NAME_REQUIRED = 16;

export interface DangerousGoodsSpecialProvisionsEntry {
  un: string;
  // Special-provision numbers, merged across the UN number's rows. Absent for the
  // UN numbers that carry none, which is most of them.
  sp?: number[] | undefined;
}

export function dangerousGoodsRequiresTechnicalNameIn(
  entries: ReadonlyArray<DangerousGoodsSpecialProvisionsEntry>,
  dangerousUnNumber: string | undefined,
): boolean {
  if (dangerousUnNumber === undefined) {
    return false;
  }
  return entries.some(
    (entry) =>
      entry.un === dangerousUnNumber &&
      (entry.sp ?? []).includes(SPECIAL_PROVISION_TECHNICAL_NAME_REQUIRED),
  );
}

/** False for an unknown UN number: we can't demand a field on data we don't have. */
export function dangerousGoodsRequiresTechnicalName(
  dangerousUnNumber: string | undefined,
): boolean {
  return dangerousGoodsRequiresTechnicalNameIn(
    dangerousGoodsData,
    dangerousUnNumber,
  );
}
